import { Link } from "@/lib/nav";

import Pill from "@buildpy/ui/pill";
import SectionCard from "@buildpy/ui/section-card";
import StageBadge from "@/modules/customer/ui/stage-badge";
import type { Customer } from "@buildpy/core/modules/customer/types";

// 카드에 보이는 최근 고객 수 — 건수는 전체를 센다.
export const NOTICE_INQUIRY_LIMIT = 5;

// 현장 상세 우측 — 이 현장 공사 안내문 QR 로 들어온 문의 건수와 최근 고객.
const NoticeInquiriesCard = ({ customers }: { customers: Customer[] }) => (
  <SectionCard className="text-sm" data-testid="project-notice-inquiries" padding="sm">
    <h2 className="mb-2 flex items-center gap-2 text-sm font-semibold">
      안내문으로 온 문의
      <span data-testid="project-notice-inquiry-count">
        <Pill tone={customers.length > 0 ? "primary" : "neutral"}>{customers.length}건</Pill>
      </span>
    </h2>
    {customers.length === 0 ? (
      <p className="text-muted-foreground">공사 안내문 QR 로 들어온 문의가 아직 없습니다.</p>
    ) : (
      <ul className="flex flex-col gap-y-2">
        {customers.slice(0, NOTICE_INQUIRY_LIMIT).map((c) => (
          <li key={c.id} className="flex min-w-0 items-center justify-between gap-2">
            <Link className="min-w-0 truncate underline-offset-2 hover:underline" href={`/app/customers/${c.id}`}>
              {c.name}
            </Link>
            <StageBadge stage={c.stage} />
          </li>
        ))}
      </ul>
    )}
  </SectionCard>
);

export default NoticeInquiriesCard;
